import { useMemo } from 'react';

export const isIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {}
  return true;
};

export const useIsIframe = () => {
  return useMemo(isIframe, []);
};

const getIsInCrossDomainIframe = () => {
  let isCrossOrigin = false;
  try {
    // If same-origin, this will succeed
    const topHost = window.top.location.host;
    const currentHost = window.location.host;
    isCrossOrigin = topHost !== currentHost;
  } catch (e) {
    // If accessing top.location throws, it's cross-origin
    isCrossOrigin = true;
  }
  return isCrossOrigin;
};

export const isInCrossDomainIframe = getIsInCrossDomainIframe();
